import React, { useState } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';

const BarRating = () => {
  const [rating, setRating] = useState(5);
  return (
    <Col xl='6' lg='12' md='6'>
      <Card>
        <HeaderCard title={'1/10 Rating'} />
        <CardBody>
          <div className='rating '>
            <Rating stop={10} initialRating={rating} emptySymbol='br-selected' fullSymbol='br-selected br-current' onChange={(rate) => setRating(rate)}></Rating>
            <span className='current-rating'>{rating}</span>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BarRating;
